import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.COMPLEX_SEIZURE_SCREENS_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/ComplexSeizureScreening/List/ComplexSeizureScreeningList.svelte"),
            title: "Complex Seizure Screening"
        }
    ]
};

export default routerConfig;